import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import customEventBus from '@common/scripts/libs/eventBus';
import Button from './Button';
import Icon from '../icon/Icon';
import classNames from 'classnames';
import { debounce } from '@common/utils/functions';
import { useLangChecker } from '@common/utils/i18n';
const ButtonPlayPause = (props) => {
    const [buttonState, setButtonState] = useState(props.initialState);
    const [waitResponse, setWaitResponse] = useState(false);
    const { t } = useTranslation();
    const updateStatus = (data) => {
        setButtonState(data.status);
        setWaitResponse(false);
    };
    //autoplay listener
    useEffect(() => {
        let uuid = props.refUUID;
        if (!!uuid) {
            customEventBus.on(`playerstatuschange:${uuid}`, updateStatus);
        }
        return () => {
            customEventBus.off(`playerstatuschange:${uuid}`, updateStatus);
        };
    }, []);
    const togglePlay = () => {
        if (waitResponse)
            return false;
        setWaitResponse(true);
        customEventBus.emit(`toggleplaypause:${props.refUUID}`, { uuid: props.refUUID, lockpause: true });
    };
    return (React.createElement(Button, { className: "button--playpause", cls: ['button--quaternary'], type: "button", ariaLabel: t('button.playpauseA11y'), ariaPressed: buttonState == 'play' ? true : false, onClick: debounce(togglePlay, 500) },
        React.createElement(React.Fragment, null,
            React.createElement(Icon, { family: '16', name: buttonState }),
            React.createElement("span", { className: classNames('button--playpause_label', { 'visually-hidden': props.hidelabel }) }, (buttonState === 'pause' && t('button.pauseshort')) || React.createElement("span", { ref: useLangChecker }, t('button.playshort'))))));
};
ButtonPlayPause.defaultProps = {
    initialState: 'play',
};
export default ButtonPlayPause;
